// CMS Client for Duus Rustfri

export const FALLBACK_NAVIGATION = [
  { id: '1', titel: 'Forside', sti: '/', sortering: 1, parent: '', fremhaevet_cta: false },
  { id: '2', titel: 'Ydelser', sti: '/ydelser', sortering: 2, parent: '', fremhaevet_cta: false },
  { id: '21', titel: 'Specialfremstilling', sti: '/ydelser/specialfremstilling', sortering: 21, parent: 'Ydelser', fremhaevet_cta: false },
  { id: '22', titel: 'Trug & Foderkrybber', sti: '/ydelser/trug-og-foderkrybber', sortering: 22, parent: 'Ydelser', fremhaevet_cta: false },
  { id: '23', titel: 'Svejsning & Rørarbejde', sti: '/ydelser/svejsning-og-roerarbejde', sortering: 23, parent: 'Ydelser', fremhaevet_cta: false },
  { id: '24', titel: 'Reparation & Smedeopgaver', sti: '/ydelser/reparation-og-smedeopgaver', sortering: 24, parent: 'Ydelser', fremhaevet_cta: false },
  { id: '25', titel: 'Have & Uderum', sti: '/ydelser/have-og-uderum', sortering: 25, parent: 'Ydelser', fremhaevet_cta: false },
  { id: '3', titel: 'Referencer', sti: '/referencer', sortering: 3, parent: '', fremhaevet_cta: false },
  { id: '5', titel: 'Om Duus Rustfri', sti: '/om-os', sortering: 5, parent: '', fremhaevet_cta: false },
  { id: '6', titel: 'Få et uforpligtende tilbud', sti: '/kontakt', sortering: 6, parent: '', fremhaevet_cta: true }
];

export const FALLBACK_YDELSER = [
  {
    id: 'ce20fdf9-6e70-46c7-8c5a-8c9678d0a014',
    slug: 'specialfremstilling',
    titel: 'Specialfremstilling i stål & aluminium',
    kort_beskrivelse: 'Skræddersyede stålløsninger og specialkonstruktioner efter mål, tegning eller idé – fra mekaniske værktøjer til kundetilpassede komponenter.',
    beskrivelse: '<p>Hos Duus Rustfri tilbyder vi skræddersyet specialfremstilling i rustfrit stål, sort stål og aluminium. Uanset om du har en færdig teknisk tegning, en simpel håndskitse eller blot en idé til en forbedring, omsætter vi det til holdbart håndværk af højeste kvalitet.</p><p>Vi arbejder tæt sammen med kunden om at finde de mest funktionelle løsninger, uanset om det gælder mekaniske specialværktøjer som øloplukkere til hele kasser, specialbeslag, stativer eller tilpasset inventar til industri og erhverv.</p>',
    billede: ['https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-699751925-122129448003136715-150113504640350210-n.jpg'],
    materialer: 'Rustfrit stål (AISI 304 / 316), sort stål, aluminium',
    fordele: 'Håndværk efter præcise mål, høj finish, fleksibel produktion i enkeltstykker eller mindre serier',
    sortering: 1,
    galleri_slug: 'galleri-specialfremstilling'
  },
  {
    id: '6d584bd4-e77a-4b4d-b391-51c06fabb5ab',
    slug: 'trug-og-foderkrybber',
    titel: 'Trug, foderkrybber & inventar',
    kort_beskrivelse: 'Fremstilling af robuste foderkrybber, trug med inddelinger og afstandsstænger, fjedermekanismer og monteringsbeslag til landbrug og industri.',
    beskrivelse: '<p>Vi fremstiller kraftige og hygiejniske trug og foderkrybber i rustfrit og galvaniseret stål, udviklet til at modstå hård daglig belastning. Vores trug udstyres med solide inddelere, afstandsstænger og gennemtænkte beslag for nem montage.</p><p>Alle overflader og samlinger udføres med fokus på dyrevelfærd, rengøringsvenlighed og maksimal levetid uden skarpe kanter.</p>',
    billede: ['https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-586549557-122097119469136715-5406239360448565138-n.jpg'],
    materialer: 'Rustfrit stål, galvaniseret stål, zink',
    fordele: 'Modstandsdygtig overfor slid og korrosion, skræddersyede længder og inddelinger, hurtig levering',
    sortering: 2,
    galleri_slug: 'galleri-trug-og-foderkrybber'
  },
  {
    id: '501b1099-683b-4a50-9789-26533e16bfd6',
    slug: 'svejsning-og-roerarbejde',
    titel: 'Svejsning & rørarbejde',
    kort_beskrivelse: 'Præcisionssvejsning af rør, flanger, gevindstudse og cylindriske komponenter i rustfrit, sort stål og aluminium.',
    beskrivelse: '<p>Præcist svejsearbejde er kernen i vores håndværk. Vi udfører TIG- og MAG-svejsning i rustfrie rør, gevindstudse, rørfittings, svejsekapsler og trykbærende eller mekaniske emner med fuld kontrol over varmeindtrængning og geometri.</p><p>Hvert svejset emne kontrolleres omhyggeligt for rethed, tæthed og overfladekvalitet, så det passer direkte ind i dit procesanlæg, maskine eller rørføring.</p>',
    billede: ['https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-646887628-122121748119136715-5214852611206569786-n.jpg'],
    materialer: 'Rustfrit stål, sort stål, gevindfittings, flanger, svejsekapsler',
    fordele: 'Rene svejsesømme, præcis vinkel og gevindplacering, holdbarhed i aggressive miljøer',
    sortering: 3,
    galleri_slug: 'galleri-svejsning-og-roerarbejde'
  },
  {
    id: 'cb040e0b-8e38-43fd-8f6b-481dc01c81ed',
    slug: 'reparation-og-smedeopgaver',
    titel: 'Reparation & smedeopgaver',
    kort_beskrivelse: 'Alt fra akutte småreparationer og forstærkninger til ombygninger af eksisterende stålkonstruktioner for private og erhverv.',
    beskrivelse: '<p>Som enkeltmandsvirksomhed tilbyder Duus Rustfri hurtig og direkte kontakt, når noget er knækket, slidt eller skal tilpasses. Vi udbedrer skader, svejser brudte komponenter sammen, forstærker svage punkter og genskaber defekte metaldetaljer.</p><p>Ingen opgave er for lille: Vi hjælper gerne med både mindre reparationer på værkstedet og tilpasning af større konstruktioner.</p>',
    billede: ['https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-648091554-122121748029136715-4881053340309711990-n.jpg'],
    materialer: 'Rustfrit stål, sort stål, aluminium',
    fordele: 'Hurtig responstid, direkte dialog med håndværkeren, ærligt og solidt arbejde',
    sortering: 4,
    galleri_slug: 'galleri-svejsning-og-roerarbejde'
  },
  {
    id: '52b467c7-76f9-4902-a5d3-9737757b0ac3',
    slug: 'have-og-uderum',
    titel: 'Have- & uderumsløsninger',
    kort_beskrivelse: 'Elegante og slidstærke cirkulære bedafgrænsninger, stålringe og uderumselementer skabt til at modstå det danske vejr.',
    beskrivelse: '<p>Til haven, terrassen og landskabsprojekter fremstiller vi stilrene stålringe og bedkanter i præcist valsede radier. De skaber skarpe, vedligeholdelsesfri overgange mellem græsplæne, bede og belægningssten.</p><p>Løsningerne kan leveres i rustfrit stål for et skarpt, moderne udtryk eller i råt stål, der med tiden patinerer naturligt.</p>',
    billede: ['https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-596981554-122107277313136715-2238372076159312811-n.jpg'],
    materialer: 'Rustfrit stål, stålplade, corten-stål',
    fordele: 'Skarpe linjer i haven, holder formen år efter år, nem montering i jord og fliser',
    sortering: 5,
    galleri_slug: 'galleri-have-og-uderum'
  }
];

export const FALLBACK_REFERENCER = [
  {
    id: '756dd648-dc62-4b3e-b88d-5108e6dd8eaf',
    slug: 'mekanisk-flaskeloefter-i-rustfrit-staal',
    titel: 'Øloplukker til hel kasse',
    opgavetype: 'Specialfremstilling & Værktøj',
    beskrivelse: '<p>Fremstilling af en specialudviklet øloplukker til hel kasse i rustfrit stål. Løsningen er udviklet til at give en hurtig, ensartet og ubesværet åbning af en hel kasse flasker på én gang.</p><p>Konstruktionen er dimensioneret for lang levetid, modstandsdygtighed mod korrosion og nem rengøring på værkstedet eller bryggeriet.</p>',
    billede: ['https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-699751925-122129448003136715-150113504640350210-n.jpg'],
    materiale: 'Rustfrit stål (AISI 304)',
    lokation: 'Vissenbjerg, Fyn',
    ydelse_slug: 'specialfremstilling',
    sortering: 1
  },
  {
    id: '8ad9ecfc-cede-4917-b2dd-fa8a8cc32c53',
    slug: 'lange-fodertrug-med-tremmer',
    titel: 'Lange fodertrug med tremmer og beslag',
    opgavetype: 'Landbrugsinventar',
    beskrivelse: '<p>Fremstilling af en serie ekstra solide metaltrug med påsvejsede tremmer og indvendige skillevægge. Trugene er udstyret med kraftige monteringsbeslag i enderne til hurtig og sikker fastgørelse på mur og staldinventar.</p><p>Konstruktionen sikrer optimal foderfordeling og modstår daglig slitage fra dyrene.</p>',
    billede: [
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-586549557-122097119469136715-5406239360448565138-n.jpg',
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-585895071-122097119181136715-4238002423184713915-n.jpg'
    ],
    materiale: 'Galvaniseret stål & zink',
    lokation: 'Fyn',
    ydelse_slug: 'trug-og-foderkrybber',
    sortering: 2
  },
  {
    id: 'b6aba072-637a-400e-80f6-b9fa262858f3',
    slug: 'praecisionssvejsede-staalroer',
    titel: 'Præcisionssvejsede rør med gevindfittings',
    opgavetype: 'Svejsning & Rørarbejde',
    beskrivelse: '<p>Serieproduktion af stålrør med påsvejsede gevindstudse og præcist vinklede rørfittings. Emnerne er svejst med høj præcision for at sikre korrekt linjeføring og absolut tæthed under tryk.</p><p>Alle svejsninger er udført efter gældende standarder med fuld kontrol over varmeudvikling og emnestabilitet.</p>',
    billede: [
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-646887628-122121748119136715-5214852611206569786-n.jpg',
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-647015786-122121748197136715-8753079384640241207-n.jpg'
    ],
    materiale: 'Stål & gevindstudse',
    lokation: 'Værksted, Vissenbjerg',
    ydelse_slug: 'svejsning-og-roerarbejde',
    sortering: 3
  },
  {
    id: '457838c5-dcfc-4270-ad86-626378b146ec',
    slug: 'specialtrug-med-fjedermekanisme',
    titel: 'Specialudviklede trug med fjedermekanisme',
    opgavetype: 'Specialproduktion',
    beskrivelse: '<p>Fremstilling af rustfrie trug udstyret med specialtilpassede fjedermekanismer og gennemgående stænger for kontrolleret dosering og nem håndtering.</p><p>Et godt eksempel på en opgave, hvor standardløsninger kom til kort, og kunden havde brug for en gennemtænkt specialløsning.</p>',
    billede: ['https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-585595685-122097119187136715-3984669561865383553-n.jpg'],
    materiale: 'Rustfrit stål',
    lokation: 'Syddanmark',
    ydelse_slug: 'trug-og-foderkrybber',
    sortering: 4
  },
  {
    id: '266f77ca-bc92-4afd-a028-455f0097e628',
    slug: 'runde-staalringe-til-haveanlaeg',
    titel: 'Runde stålringe til haveanlæg',
    opgavetype: 'Have & Uderum',
    beskrivelse: '<p>Valsede cirkulære bedringe i stål leveret og monteret på mørkegrå terrassefliser i forbindelse med anlæggelse af et moderne havemiljø.</p><p>Ringene giver et skarpt, arkitektonisk udtryk omkring beplantningen og holder formen perfekt mod jordtryk og græstrimmer.</p>',
    billede: ['https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-596981554-122107277313136715-2238372076159312811-n.jpg'],
    materiale: 'Stål / valsede stålringe',
    lokation: 'Fyn',
    ydelse_slug: 'have-og-uderum',
    sortering: 5
  }
];

export const FALLBACK_GALLERI = [
  {
    id: 'ecb8a4f7-e0bc-468c-b4ff-259285454f6e',
    slug: 'galleri-specialfremstilling',
    titel: 'Specialfremstilling & Mekaniske løsninger',
    kategori: 'Specialfremstilling',
    billeder: [
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-699751925-122129448003136715-150113504640350210-n.jpg',
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-646865653-122121748077136715-5791897527669142794-n.jpg'
    ],
    alt_tekster: 'Specialfremstillet øloplukker til hel kasse i rustfrit stål || Svejste cylindriske stålemner med kuppelformede ender',
    beskrivelse: 'Kundetilpassede stålløsninger og mekaniske hjælpemidler.',
    sortering: 1
  },
  {
    id: 'a8e3a1c5-44c4-48e6-a4f6-7ab52d6193d0',
    slug: 'galleri-trug-og-foderkrybber',
    titel: 'Trug & Foderkrybber til landbrug',
    kategori: 'Landbrug & Inventar',
    billeder: [
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-586549557-122097119469136715-5406239360448565138-n.jpg',
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-585895071-122097119181136715-4238002423184713915-n.jpg',
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-585595685-122097119187136715-3984669561865383553-n.jpg',
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-584371785-122097119163136715-26002098398714460-n.jpg'
    ],
    alt_tekster: 'Tre lange fodertrug oprejst mod mur || Metaltrug med inddelinger på arbejdsbord || Trug med fjedermekanisme og stænger || Lange metaltrug på værksted',
    beskrivelse: 'Fremstilling af kraftige trug og foderkrybber i rustfrit og galvaniseret stål.',
    sortering: 2
  },
  {
    id: 'bbcd103a-3af5-432f-a795-9612fdce12d3',
    slug: 'galleri-svejsning-og-roerarbejde',
    titel: 'Svejsning, Rør & Fittings',
    kategori: 'Svejsning & Rørarbejde',
    billeder: [
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-646887628-122121748119136715-5214852611206569786-n.jpg',
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-647015786-122121748197136715-8753079384640241207-n.jpg',
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-648091554-122121748029136715-4881053340309711990-n.jpg',
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-646865653-122121748077136715-5791897527669142794-n.jpg'
    ],
    alt_tekster: 'Svejset rør i skruestik med vaterpas || Sammensvejsede stålrør med gevindstudse på palle || Sorterede komponenter og rørfittings på arbejdsbord || Svejsede cylindriske emner med kuppeltoppe',
    beskrivelse: 'TIG- og MAG-svejsning af rørkonstruktioner, studse og fittings.',
    sortering: 3
  },
  {
    id: '554bbc03-1bb2-4154-a6fc-d5b41348aff9',
    slug: 'galleri-have-og-uderum',
    titel: 'Have- & Bedafgrænsninger i stål',
    kategori: 'Have & Uderum',
    billeder: [
      'https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-596981554-122107277313136715-2238372076159312811-n.jpg'
    ],
    alt_tekster: 'Runde metalringe til havebede på fliseterrasse',
    beskrivelse: 'Runde bedafgrænsninger i stål til haver og udendørs anlæg.',
    sortering: 4
  }
];

export const FALLBACK_VIRKSOMHED = {
  firmanavn: 'Duus Rustfri',
  undertitel: 'Enkeltmandsvirksomhed · Rustfri, Sort & Alu',
  cvr: '45898644',
  telefon: '30 27 16 71',
  email: 'Duus.rustfri@gmail.com',
  adresse: 'Bakkevej 17',
  postnr_by: '5492 Vissenbjerg',
  omraade: 'Fyn & hele landet',
  aabningstider: 'Mandag - Fredag: 07:00 - 16:00 (Lørdag - Søndag: Efter aftale)',
  facebook_url: 'https://www.facebook.com',
  logo: ['https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/duus-logo-transparent.png'],
  footer_tekst: 'Enkeltmandsvirksomhed med passion for solidt håndværk. Vi tilbyder alt fra små reparationer til skræddersyede specialløsninger i rustfrit stål, sort stål og aluminium.'
};

export const FALLBACK_VAERDIER = [
  {
    id: '1',
    titel: 'Direkte kontakt',
    beskrivelse: 'Du taler direkte med den faglærte smed, der udfører arbejdet. Det minimerer misforståelser og sikrer hurtig afklaring.',
    ikon: 'fa-comments',
    sortering: 1
  },
  {
    id: '2',
    titel: 'Fleksibilitet & specialmål',
    beskrivelse: 'Ingen standardbegrænsninger. Vi tilpasser konstruktionen nøjagtigt efter dine dimensioner, skitser eller eksisterende inventar.',
    ikon: 'fa-shapes',
    sortering: 2
  },
  {
    id: '3',
    titel: 'Høj finish & holdbarhed',
    beskrivelse: 'Vi går ikke på kompromis med samlinger, svejsesømme eller afgratning. Emnerne leveres rene, plane og klar til brug.',
    ikon: 'fa-award',
    sortering: 3
  },
  {
    id: '4',
    titel: 'Ærlige aftaler',
    beskrivelse: 'Du får en reel vurdering af opgaven, en klar pris og en leveringstid, der holder. En aftale er en aftale.',
    ikon: 'fa-handshake',
    sortering: 4
  }
];

export const FALLBACK_SIDER = {
  'forside': {
    titel: 'Duus Rustfri',
    meta_beskrivelse: 'Duus Rustfri – Enkeltmandsvirksomhed i Vissenbjerg med speciale i rustfrit stål, sort stål og aluminium. Alt fra små reparationer til specialløsninger.',
    overskrift: 'Specialløsninger og godt håndværk i rustfrit stål, sort & alu',
    underoverskrift: 'Jeg sætter en ære i godt håndværk og tilbyder alt fra små reparationer til skræddersyede specialløsninger, foderkrybber og præcisionssvejsning for private og erhverv.',
    badge: 'Enkeltmandsvirksomhed på Fyn',
    billede: ['https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-646887628-122121748119136715-5214852611206569786-n.jpg'],
    sekundaert_billede: ['https://assets.auxodev.dk/assets/22e5a7c6-e40d-4b26-8ee0-cb7d2891cbe9/imgi-21-699751925-122129448003136715-150113504640350210-n.jpg'],
    cta_tekst: 'Send en bestillingsforespørgsel',
    cta_link: '#bestil',
    sekundaer_cta_tekst: 'Ring på 30 27 16 71',
    fordele: 'Direkte kontakt | Skræddersyet efter mål | Uforpligtende tilbud',
    sektion_2_badge: 'Om virksomheden',
    sektion_2_overskrift: 'Enkeltmandsvirksomhed med passion for solidt håndværk',
    sektion_2_tekst: '<p>Hos Duus Rustfri er du sikret direkte kontakt fra start til slut. Ingen fordyrende mellemled eller bureaukrati – du taler direkte med håndværkeren, der udfører opgaven.</p><p>Jeg sætter en ære i veludført arbejde og anvender kun kvalitetsmaterialer inden for rustfrit stål, sort stål og aluminium. Uanset om opgaven gælder en hurtig reparation af en knækket komponent eller udvikling af en komplet specialløsning, går jeg til arbejdet med samme faglige omhu.</p>',
    sektion_3_overskrift: 'Hold dig opdateret med nye projekter',
    sektion_3_tekst: 'Få opdateringer om specialløsninger, nyt fra værkstedet og gode råd direkte i din indbakke.',
    ekstra_tal: 'Værksted & Montage | Præcision i hver eneste svejsning'
  },
  'ydelser': {
    titel: 'Ydelser - Duus Rustfri',
    meta_beskrivelse: 'Oversigt over ydelser hos Duus Rustfri. Specialfremstilling, svejsning, trug og foderkrybber, smedeopgaver og havebede.',
    overskrift: 'Ydelser & Produkter',
    underoverskrift: 'Kundetilpassede metalløsninger i rustfrit stål, sort stål og aluminium tilpasset dine specifikke behov.'
  },
  'referencer': {
    titel: 'Referencer - Duus Rustfri',
    meta_beskrivelse: 'Se udvalgte projekter og referencer udført af Duus Rustfri. Håndværk af høj kvalitet i rustfrit stål og metal.',
    overskrift: 'Referencer & Projekter',
    underoverskrift: 'Et udpluk af vores arbejde for landbrug, industri og private kunder på Fyn og i resten af Danmark.'
  },
  'galleri': {
    titel: 'Galleri - Duus Rustfri',
    meta_beskrivelse: 'Billedgalleri med eksempler på smedearbejde, svejsning og specialfremstilling fra Duus Rustfri i Vissenbjerg.',
    overskrift: 'Billedgalleri',
    underoverskrift: 'Se billeder fra vores værksted, færdige komponenter, svejsninger og montage.'
  },
  'om-os': {
    titel: 'Om Duus Rustfri - Duus Rustfri',
    meta_beskrivelse: 'Lær Duus Rustfri at kende. Enkeltmandsvirksomhed med passion for gedigent smede- og svejsehåndværk i rustfrit stål, sort og alu.',
    overskrift: 'Om Duus Rustfri',
    underoverskrift: 'Enkeltmandsvirksomhed på Fyn med stolthed i faget, fleksibilitet og direkte kontakt.'
  },
  'kontakt': {
    titel: 'Kontakt - Duus Rustfri',
    meta_beskrivelse: 'Kontakt Duus Rustfri for et uforpligtende tilbud på specialfremstilling, svejsning eller reparation i stål. Ring 30 27 16 71.',
    overskrift: 'Kontakt & Forespørgsel',
    underoverskrift: 'Send en konkret bestillingsforespørgsel eller ring direkte for en snak om din opgave.'
  }
};

export async function fetchCollection(collectionName, fallback = []) {
  try {
    const res = await fetch(`/_api/public/content/${collectionName}`);
    if (!res.ok) return fallback;
    const data = await res.json();
    if (Array.isArray(data) && data.length > 0) {
      return data;
    }
    return fallback;
  } catch {
    return fallback;
  }
}

export async function fetchCollectionV2(collectionName, query = '', fallback = []) {
  try {
    const url = `/_api/public/v2/content/${collectionName}${query ? '?' + query : ''}`;
    const res = await fetch(url);
    if (!res.ok) return { items: fallback, total: fallback.length };
    const data = await res.json();
    if (data && Array.isArray(data.items) && data.items.length > 0) {
      return data;
    }
    return { items: fallback, total: fallback.length };
  } catch {
    return { items: fallback, total: fallback.length };
  }
}

export function getSlug(item) {
  if (!item) return '';
  if (typeof item.slug === 'string') return item.slug;
  if (typeof item.slug === 'object' && item.slug !== null) {
    return item.slug.da || Object.values(item.slug)[0] || '';
  }
  return item.id || '';
}

export async function fetchVirksomhedsoplysninger() {
  try {
    const list = await fetchCollection('virksomhedsoplysninger', [FALLBACK_VIRKSOMHED]);
    if (Array.isArray(list) && list.length > 0) {
      return { ...FALLBACK_VIRKSOMHED, ...list[0] };
    }
    return FALLBACK_VIRKSOMHED;
  } catch {
    return FALLBACK_VIRKSOMHED;
  }
}

export async function fetchSide(sideSlug) {
  try {
    const list = await fetchCollection('sider', []);
    if (Array.isArray(list) && list.length > 0) {
      const match = list.find((item) => {
        const s = getSlug(item);
        return s === sideSlug || s === `${sideSlug}-sider` || item.titel?.toLowerCase().includes(sideSlug);
      });
      if (match) {
        return { ...(FALLBACK_SIDER[sideSlug] || {}), ...match };
      }
    }
    return FALLBACK_SIDER[sideSlug] || {};
  } catch {
    return FALLBACK_SIDER[sideSlug] || {};
  }
}

export async function fetchVaerdier() {
  try {
    const list = await fetchCollection('vaerdier', FALLBACK_VAERDIER);
    if (Array.isArray(list) && list.length > 0) {
      return [...list].sort((a, b) => (Number(a.sortering) || 0) - (Number(b.sortering) || 0));
    }
    return FALLBACK_VAERDIER;
  } catch {
    return FALLBACK_VAERDIER;
  }
}


